import { Chip, Divider, Stack, Typography } from '@mui/material';
import { CloseIcon, FilterIcon } from '~/icons';
import { useTableFilters } from './context';
import { ClearAllButton } from './filters';
import { appliedFiltersSummaryRowStyles } from './styles';

const TableFiltersToolbarStatusPanel = () => {
  const { appliedFilters, deleteFilter, resultsCount, open } = useTableFilters();
  const filtersLength = Object.values(appliedFilters).flat().length;

  if (!filtersLength) return null;

  return (
    <Stack sx={{ width: '100%', backgroundColor: '#fff' }}>
      <Stack direction="row" spacing={2} p={2} alignItems="center" sx={appliedFiltersSummaryRowStyles}>
        <FilterIcon fill="#008EFF" />
        <Typography fontSize="16px">
          Applied Filters: {resultsCount ?? 0} search results from {filtersLength} filter input
          {filtersLength !== 1 ? 's' : ''}
        </Typography>
      </Stack>
      <Stack direction="row" p={2} spacing={1} alignItems="center">
        <Typography>{`${filtersLength} filter${filtersLength > 1 ? 's' : ''} applied`}</Typography>
        <Divider orientation="vertical" sx={{ height: '2rem' }} />
        <ClearAllButton />
        <Divider orientation="vertical" sx={{ height: '2rem' }} />
        <Stack direction="row" flexWrap="wrap" gap={1} pr={8} sx={{ maxWidth: open ? 'calc(100% - 350px)' : '100%' }}>
          {Object.keys(appliedFilters).flatMap((filterId) =>
            appliedFilters[filterId].map(({ id, label }) => (
              <Chip
                key={id}
                sx={{ fontSize: '14px' }}
                variant="outlined"
                size="small"
                label={label}
                onDelete={() => deleteFilter?.(filterId, id)}
                deleteIcon={<CloseIcon />}
              />
            )),
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default TableFiltersToolbarStatusPanel;
